export default {
  "content": "<title>Shuffle</title><path d=\"M400 304l48 48-48 48m0-288l48 48-48 48M64 352h128l60-92\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M64 160h128l128 192h96m0-192h-96l-32 48\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};